/** @module csi/skintheme/OceanWave */
define([], function() {
	return {
		Blue1: "Cyan30",
		Blue2: "Cyan50",
		Blue3: "Cyan400",

		PrimaryBlue: "Cyan700",
		PrimaryDisabledColor: "Cyan200",
		PrimaryColor2: "Cyan800",
		PrimaryColor3: "Cyan900",

		SiteHeaderBackground: "Cyan700",

		CompanyHeaderBlue1: "Cyan700",
		CompanyHeaderBlue2: "Cyan800",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Cyan500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Cyan700",
		FullScreenLogoBackgroundColor: "Cyan700",

		/* TEXT */
		TabsTextActive: "Cyan700",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Cyan900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Cyan700",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* Text Border */
		TextfieldActiveBorderColor: "PrimaryColor",
		BtnToolbarFocusedBorderColor: "PrimaryColor",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* CheckBox */
		CheckBoxFocusColor: "Cyan300",

		/* Header */
		LastVisitedBackgroundColor: "PrimaryWhite",
		LastVisitedIconColor: "SiteHeaderBackground",
		PageHeaderButtonTextColor: "PrimaryWhite",
		PageHeaderToolbarIconColor: "PrimaryWhite",
		PageHeaderToolbarHoverColor: "PrimaryWhite",
		PageHeaderSearchInButtonHoverColor: "BtnSecondaryHoverBackgroundColor",
		PageHeaderToolbarSeparatorColor: "WhiteOpacity20",
		PageHeaderSearchScopeBackgroundColor: "BtnSecondaryNormalBackgroundColor",
		PageHeaderSearchBlockBackgroundColor: "TextfieldNormalBackgroundColor",
		CompanyLogoTextColor: "WhiteTextColor",
		CompanyLogoImageURL: "DarkCompanyLogoIconURL",
		ExitFullScreenIconURL: "DarkExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Cyan600",
		TablePasteBorderColor: "Cyan600",
		TableNewRowBackgroundColor: "Cyan100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Cyan100",

		/* Chart */
		ChartAreaURL: "ChartAreaCyanURL",
		ChartBarURL: "ChartBarCyanURL",
		ChartColumnURL: "ChartColumnCyanURL",
		ChartDoughnutURL: "ChartDoughnutCyanURL",
		ChartLineURL: "ChartLineCyanURL",
		ChartMsAreaURL: "ChartMsAreaCyanURL",
		ChartMsBarURL: "ChartMsBarCyanURL",
		ChartMsColumnURL: "ChartMsColumnCyanURL",
		ChartMsLineURL: "ChartMsLineCyanURL",
		ChartParetoURL: "ChartParetoCyanURL",
		ChartPieURL: "ChartPieCyanURL",
		ChartStackedAreaURL: "ChartStackedAreaCyanURL",
		ChartStackedBarURL: "ChartStackedBarCyanURL",
		ChartStackedColumnURL: "ChartStackedColumnCyanURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Cyan50"
	};
});